var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeginnersStudents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1563",
    "data-name": "Group 1563",
    transform: "translate(10281 22613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13336",
    "data-name": "Group 13336"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 68,
    height: 63,
    rx: 12,
    transform: "translate(-10281 -22613)",
    fill: "#3488eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Student",
    transform: "translate(-10265.788 -22599.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M26.029,13.71a1.053,1.053,0,0,1-1.053-1.053V7.466a1.053,1.053,0,1,1,2.106,0v5.191A1.053,1.053,0,0,1,26.029,13.71Z",
    transform: "translate(3.432 0.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M28.281,24.036a15.847,15.847,0,0,0-5.713-2.677,11.418,11.418,0,0,0,4.523-9.379,13.167,13.167,0,0,0-.106-1.574l2.923-1.273a1.689,1.689,0,0,0,0-3.1L19.186,1.368a3.211,3.211,0,0,0-2.559,0L5.905,6.037a1.689,1.689,0,0,0,0,3.1l2.918,1.272a13.122,13.122,0,0,0-.1,1.575,11.42,11.42,0,0,0,4.518,9.376,15.764,15.764,0,0,0-5.713,2.678A7.147,7.147,0,0,0,4.788,29.72v3.05a3.2,3.2,0,0,0,3.193,3.194H27.83a3.194,3.194,0,0,0,3.193-3.188V29.722a7.147,7.147,0,0,0-2.741-5.686ZM17.9,26.852l-2.415-3.8a17.172,17.172,0,0,1,4.824,0ZM17.467,3.3a1.1,1.1,0,0,1,.876,0l9.844,4.288-9.844,4.288a1.1,1.1,0,0,1-.876,0L7.624,7.586Zm-6.64,8.682c0-.234.036-.454.05-.681l5.749,2.5a3.214,3.214,0,0,0,2.559,0l5.769-2.513c.014.229.029.457.029.689,0,4.851-3.175,8.8-7.078,8.8s-7.078-3.946-7.078-8.8ZM6.894,32.771v-3.05A5.036,5.036,0,0,1,8.8,25.71a13.532,13.532,0,0,1,4.482-2.187l3.568,5.609v4.727H7.982a1.089,1.089,0,0,1-1.088-1.088Zm22.023.007a1.084,1.084,0,0,1-1.087,1.081H18.959V29.114l3.547-5.593a13.571,13.571,0,0,1,4.5,2.19,5.039,5.039,0,0,1,1.911,4.012Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginnersStudents);
export default __webpack_public_path__ + "static/media/beginners-students.68b9a6c20cd0ebb846702d5611a6d0c9.svg";
export { ForwardRef as ReactComponent };